export default __webpack_public_path__ + "static/media/card.d26abb11.png";